import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { useServices } from "@core/servicesContext";
import { isEmail } from "@utils/regex";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { Primary } from "@ui/components/containers/primary";
import { MailIcon } from "@ui/components/icons";
import { useForm } from "@ui/components/inputs/hooks";
import { SimpleTextInput } from "@ui/components/inputs/simpleTextInput";
import { ClosableModal } from "@ui/modals/closableModal";
import { createToast } from "@ui/toasts/utils";

interface ChangeEmailModalProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
}
export const ChangeEmailModal: React.FC<ChangeEmailModalProps> = ({ close, ...htmlProps }) => {
	const { fieldProps, checkSubmit, formValue } = useForm({ email: "" }, ["email"], { email: isEmail });
	const { currentProfileService } = useServices();
	//const [loading, setLoading] = useState(false);

	const changeEmailStepOne = async (): Promise<void> => {
		//setLoading(true);
		try {
			const fetchedChangedEmail = await currentProfileService.changeEmail(formValue.email);
			createToast(I18n.t("success"), I18n.t("settings.change.email.message"), "success");
			return fetchedChangedEmail;
		} catch (e) {
			console.error(e);
			createToast(I18n.t("error"), I18n.t("auth.error.default"), "error");
		} finally {
			//setLoading(false);
		}
	};

	return (
		<Container close={close} {...htmlProps}>
			<ContainerLabel>
				<Primary>
					<b>{I18n.t("settings.change.email.placeholder")}</b>
				</Primary>
			</ContainerLabel>
			<FormContainer
				onSubmit={(e) => {
					e.preventDefault();
					if (!checkSubmit()) {
						return;
					}
					changeEmailStepOne();
					close();
				}}
			>
				<SimpleTextInput
					icon={<MailIcon />}
					iconPosition="left"
					type="email"
					{...fieldProps("email")}
					placeholder={I18n.t("email.placeholder")}
				/>
				<ContainerBtn>
					<PrimaryButton type="submit">{I18n.t("password.forgotten.button")}</PrimaryButton>
				</ContainerBtn>
			</FormContainer>
		</Container>
	);
};

const Container = styled(ClosableModal)`
	padding: 60px;
`;

const FormContainer = styled.form`
	margin-top: 10px;
	.input-wrapper > svg .main-path {
		fill: ${({ theme }) => theme.colors.primary};
	}
`;
const ContainerBtn = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 30px;
`;
const ContainerLabel = styled.div`
	display: flex;
`;
